import React from "react";
import { Box, Typography } from "@mui/material";

export function PromotionsTab() {
    return <Box sx={{ p: '5px', pb: '25px' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>Promotions</Typography>
            <form id="tab">
                <label className="labels">Setup Promotion<br/>
                    <textarea type="text" name="setup-promo" rows="5"/>
                </label>

                <label className="labels">Time Based<br/>
                    <input type="date" name="promo-time"/>
                </label>

                <label className="labels">Rule Based<br/>
                    <input type="text" name="promo-rule"/>
                </label>
                <label>
                    <button type="submit" className="save-button" value="Submit">Save</button>
                </label>
            </form>
    </Box>;
}

